import { render, staticRenderFns } from "./ScheduledReportsCard.vue?vue&type=template&id=e32c50e0"
import script from "./ScheduledReportsCard.vue?vue&type=script&lang=js"
export * from "./ScheduledReportsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports